// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__16n6H","label":"Labeled_label__3DNGN","divider":"Labeled_divider__2rjzn"};